import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as Add } from '../../images/default-post-icon.svg';

export const DefaultPostIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={Add} />
);

export default DefaultPostIcon;
